import { memo } from 'react';

import { Form } from '@components/form';
import { useLocale } from '@locale/translate';

import { PhoneField } from './types';
import { getTranslatedFormText } from './utils';

export const PhoneInput = memo<{ field: PhoneField }>(({ field }) => {
  const currentLanguage = useLocale();

  return (
    <Form.PhoneField
      {...field}
      label={getTranslatedFormText(field.text, currentLanguage)}
      defaultValue={field.value}
    />
  );
});
